<template>
    <div class="row mt-4">
        <div class="col-md-6 mb-3">
            <strong class="mb-2">
                {{ trans('general.module.report.update_popup.step.details.choose_type') }}
            </strong>
            <custom-radio
                v-if="bathroomTypes"
                v-model="selectedBathroomTypeOption"
                :items="bathroomTypesDesigner"
                type="list"/>
        </div>
        <div class="col-md-6 mt-2 mb-4">
            <div class="btn btn-sm btn-outline btn-fluid"
                 @click="bathTime = !bathTime" role="button">
                {{ trans('general.module.report.update_popup.step.details.has_slept_info') }}
                <i :class="['fi', bathTime ? 'fi-rr-angle-up' : 'fi-rr-angle-down']"></i>
            </div>
            <div class="d-flex justify-content-between align-items-center" v-if="bathTime">
                <scroll-picker
                    :key="'fromh' + data.value"
                    v-if="hours"
                    :items="hours"
                    @select="hoursFromSelectedOption = $event"
                    :selected="hoursFromSelectedOption"/>

                <scroll-picker
                    v-if="minutes"
                    :key="'fromm' + data.value"
                    :items="minutes"
                    @select="minutesFromSelectedOption = $event"
                    :selected="minutesFromSelectedOption"/>
            </div>
        </div>

    </div>
</template>

<script>
import GeneralReportForm from "../GeneralReportForm.vue";
import CustomRadio from "../../../../theme/molecules/CustomRadio.vue";
import ScrollPicker from "../../../../theme/molecules/ScrollPicker.vue";
import {BATHROOM_TYPES, BATHROOM_TYPES_DESIGNER} from "../../../../services/Defaults";
import moment from "moment";

export default {
    name: "Bathroom",
    extends: GeneralReportForm,
    components: {CustomRadio, ScrollPicker},
    data() {
        return {
            model: {
                ...this.value,
                type: null,
                when: this.getFrom(),
            },
            selectedBathroomTypeOption: null,
            bathTime: false,
        };
    },
    computed: {
        bathroomTypes() {
            return Object.values(BATHROOM_TYPES)
        },
        bathroomTypesDesigner() {
            return this.getSelectItems(
                Object.entries(BATHROOM_TYPES_DESIGNER),
                'general.module.bathroom_type'
            )
        },
    },
    watch: {
        model: {
            handler: function (value) {
                this.internalUpdate = true;
                this.$emit('input', value);
            },
            deep: true
        },
        selectedBathroomTypeOption: function () {
            this.model.type = this.selectedBathroomTypeOption.value;
        },
        hoursFromSelectedOption: function () {
            this.model.when = this.getFrom();
        },
        minutesFromSelectedOption: function () {
            this.model.when = this.getFrom();
        },
    },
    methods: {
        getFrom() {
            if(!this.bathTime) {
                return moment().format('YYYY-MM-DD HH:mm:ss');
            } else {
                const from = `${this.hoursFromSelectedOption.value}:${this.minutesFromSelectedOption.value}`;
                return moment(from, 'HH:mm').format('YYYY-MM-DD HH:mm:ss');
            }
        },
    },
};
</script>
